import styled from 'styled-components';
import { Text } from 'foundations-components/components/Text';
import FormattedInvoicePropertyLabelAndValue from 'invoices-ui-lib/components/FormattedInvoicePropertyLabelAndValue';
import { getInvoiceProperty } from 'invoices-ui-lib/utils/property';
import NextReminderDate from './NextReminderDate';
import { InvoiceStatus } from 'invoices-ui-lib/constants/status';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "InvoiceHighlightDetails__StyledDiv",
  componentId: "lt38w0-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    textAlign: 'left',
    marginTop: theme.space['400'],
    marginBottom: theme.space['400']
  };
});
const InvoiceHighlightDetails = ({
  invoice,
  propertyDefinitions,
  allowEmailReminders,
  accountApprovedForPayments,
  isPollingForNextReminderDate
}) => {
  const invoiceStatus = getInvoiceProperty(invoice, 'hs_invoice_status');
  return /*#__PURE__*/_jsxs(StyledDiv, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h3",
      marginBlockEnd: "200",
      "data-test-id": `invoices-preview-header-${invoice.objectId}`,
      children: /*#__PURE__*/_jsx(FormattedInvoicePropertyLabelAndValue, {
        "data-test-id": "invoice-highlight-header-content",
        invoice: invoice,
        propertyDefinitions: propertyDefinitions,
        propertyName: "hs_number",
        displayLabel: false
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "100",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedInvoicePropertyLabelAndValue, {
        "data-test-id": "invoice-highlight-amount-billed-content",
        invoice: invoice,
        propertyDefinitions: propertyDefinitions,
        propertyName: "hs_amount_billed"
      })
    }), /*#__PURE__*/_jsx(View, {
      "data-test-id": `invoice-status-${invoiceStatus}`,
      marginBlockEnd: "100",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedInvoicePropertyLabelAndValue, {
        "data-test-id": "invoice-highlight-status-content",
        invoice: invoice,
        propertyDefinitions: propertyDefinitions,
        propertyName: "hs_invoice_status"
      })
    }), accountApprovedForPayments && allowEmailReminders && invoiceStatus === InvoiceStatus.OPEN && /*#__PURE__*/_jsx(NextReminderDate, {
      invoice: invoice,
      isPollingForNextReminderDate: isPollingForNextReminderDate
    })]
  });
};
export default InvoiceHighlightDetails;